var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1.9585C19.25 2.3335 18.5 2.4585 17.625 2.5835C18.5 2.0835 19.125 1.3335 19.375 0.333496C18.625 0.833496 17.75 1.0835 16.75 1.3335C16 0.583496 14.875 0.0834961 13.75 0.0834961C11.125 0.0834961 9.125 2.5835 9.75 5.0835C6.375 4.9585 3.375 3.3335 1.25 0.833497C0.125 2.7085 0.75 5.0835 2.5 6.3335C1.875 6.3335 1.25 6.0835 0.625 5.8335C0.625 7.7085 2 9.4585 3.875 9.9585C3.25 10.0835 2.625 10.2085 2 10.0835C2.5 11.7085 4 12.9585 5.875 12.9585C4.375 14.0835 2.125 14.7085 0 14.4585C1.875 15.5835 4 16.3335 6.25 16.3335C13.875 16.3335 18.125 9.9585 17.875 4.0835C18.75 3.5835 19.5 2.8335 20 1.9585Z",
    fill: "#FF2F37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterRed);
export default __webpack_public_path__ + "static/media/twitter-red.0eade7db69da9b74d9d56b5ad5b6bcc2.svg";
export { ForwardRef as ReactComponent };